import React, { useState, useContext } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useMutation, gql } from '@apollo/client';
import { useSnackbar } from '../../SnackbarContext';
import ContactForm from './ContactForm';
import ContactDetails from './ContactDetails';
import { AppContext } from '../../AppContext'; // Update this line
import { CREATE_CONTACT, UPDATE_CONTACT, DELETE_CONTACT } from '../queries';

const ContactContent = (props) => {
  const { 
    id, 
    firstName,
    lastName,
    title,
    company,
    email,
    phone,
    notes,
    linkedinUrl,
    linkedinPhotoUrl,
    createdAt,
    updatedAt
  } = props;
  // const id = '12345';
  // const firstName = 'John';
  // const lastName = 'Doe';

  const isAddingNew = !id;
  const { globalOnSave } = useContext(AppContext);
  const [isEditing, setIsEditing] = useState(isAddingNew);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { showSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({ 
    id, 
    firstName,
    lastName,
    title,
    company,
    email,
    phone,
    notes,
    linkedinUrl,
    linkedinPhotoUrl,
    createdAt,
    updatedAt
  });

  const [originalData, setOriginalData] = useState({ 
    id, 
    firstName,
    lastName,
    title,
    company,
    email,
    phone,
    notes,
    linkedinUrl,
    linkedinPhotoUrl,
    createdAt,
    updatedAt
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [discardDialogOpen, setDiscardDialogOpen] = useState(false);
  console.log("Props Main", props);

  const [createContact] = useMutation(CREATE_CONTACT, {
    onCompleted: () => {
      setIsEditing(false);
      showSnackbar({ message: 'New contact created!', severity: 'success' });
      globalOnSave();
      console.log("New contact created!");
      props.closeDrawer();
    },
    onError: (error) => {
      console.error('Error creating contact:', error);
    }
  });

  const [updateContact] = useMutation(UPDATE_CONTACT, {
    onCompleted: () => {
      showSnackbar({ message: 'Contact updated!', severity: 'success' });
      setIsEditing(false);
      props.refetch && props.refetch();
      props.closeDrawer();
    },
    onError: (error) => {
      console.error('Error updating contact:', error);
    }
  });

  const handleEditClick = () => {
    setIsEditing(true);
  };
  console.log(props);
  const [deleteContact] = useMutation(DELETE_CONTACT, {
    onCompleted: () => {
      showSnackbar({ message: 'Contact Deleted!', severity: 'success' });
      console.log(props.refetch);
      props.refetch && props.refetch();
      props.closeDrawer();
     // refetch(); // Trigger a refetch of the job opportunities
      //props.closeDrawer; // Close the right drawer
      
    },
    onError: (error) => {
      console.error('Error deleting Contact:', error);
    }
  });

  const handleSaveClick = () => {
    console.log('Input data being sent:', formData);
    if (id) {
      updateContact({ variables: { input: { id, ...formData } } });
    } else {
      createContact({ variables: { input: formData } });
    }
  };

  const handleCancelClick = () => {
    if(id) {
      if (JSON.stringify(formData) !== JSON.stringify(originalData)) {
        setDiscardDialogOpen(true);
      } else {
        setIsEditing(false);
      }
    } else {
      props.closeDrawer();
    }
  };

  const handleDiscardChanges = () => {
    setFormData(originalData);
    setIsEditing(false);
    setDiscardDialogOpen(false);
  };

  const handleCloseDiscardDialog = () => {
    setDiscardDialogOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <Box sx={{ padding: 2 }}>
      {isEditing ? (
        <ContactForm
          formData={formData}
          handleChange={handleChange}
          handleSaveClick={handleSaveClick}
          handleCancelClick={handleCancelClick}
          
        />
      ) : (
        <ContactDetails
          formData={formData}
          handleEditClick={handleEditClick}
          deleteContact={deleteContact}
        />
      )}
      <Dialog
        open={discardDialogOpen}
        onClose={handleCloseDiscardDialog}
      >
        <DialogTitle>Discard changes?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Discard changes to this contact?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDiscardDialog} color="primary">
            No
          </Button>
          <Button onClick={handleDiscardChanges} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ContactContent;